export default __webpack_public_path__ + "static/door_w.7c4a286301af2ff4657e7cfdb871d5df.svg";